import { render, staticRenderFns } from "./TransferSuccess.vue?vue&type=template&id=5e429f16&scoped=true"
import script from "./TransferSuccess.vue?vue&type=script&lang=js"
export * from "./TransferSuccess.vue?vue&type=script&lang=js"
import style0 from "./TransferSuccess.vue?vue&type=style&index=0&id=5e429f16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e429f16",
  null
  
)

export default component.exports